import * as LabelPrimitive from "@radix-ui/react-label"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

export type SwitchProps = {
  label?: string
  ref?: React.Ref<HTMLButtonElement>
} & SwitchPrimitive.SwitchProps

export function Switch({ label, className, ref, ...props }: SwitchProps) {
  return (
    <div className={cn("flex items-center", className)}>
      <SwitchPrimitive.Root
        {...props}
        className={cn(
          "focus-outline group peer shrink-0 border-muted-foreground",
          "flex h-6 w-11 items-center rounded-full bg-muted-foreground enabled:aria-checked:bg-primary rebrand:enabled:aria-checked:bg-primary-foreground",
          "disabled:cursor-not-allowed disabled:opacity-50",
        )}
        ref={ref}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            "block size-4 translate-x-1 rounded-full transition-transform will-change-transform",
            "bg-neutral group-aria-checked:bg-primary-foreground rebrand:group-aria-checked:bg-primary",
            "group-aria-checked:translate-x-6",
          )}
        />
      </SwitchPrimitive.Root>
      {label ? (
        <LabelPrimitive.Root
          htmlFor={props.id}
          className={cn(
            "pl-2 select-none peer-enabled:cursor-pointer",
            "text-foreground peer-disabled:cursor-not-allowed peer-disabled:text-muted-foreground/60",
          )}
        >
          <span className="text-body1 text-current">{label}</span>
        </LabelPrimitive.Root>
      ) : null}
    </div>
  )
}
